import Spinner from 'react-bootstrap/Spinner';

function LoaderSpinner() {
  return (
    <div
      className="position-absolute justify-content-center align-items-center w-100 vh-100 top-0 start-0 end-0 bottom-0 d-flex z-1"
      style={{ backgroundColor: 'rgb(0 0 0 / 85%)' }}
    >
      <Spinner animation="border" variant="light" style={{ width: '3rem', height: '3rem', borderWidth: '0.45em' }} />
    </div>
  );
}

export default LoaderSpinner;
